/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { useState, useEffect, Component } from 'react';
import PropTypes from 'prop-types';
import immutablePropTypes from 'react-immutable-proptypes';
import { generateDrilldownReport } from 'reporting-data/config/drilldown/generate';
import { fromJS } from 'immutable';
import I18n from 'I18n';
import { resolve } from 'reporting-data/main';
import { reportsEqual } from 'reporting-ui-components/lib/shallowCompareReports';
import { RaiseError } from 'reporting-ui-components/trap/ErrorTrap';
import { RaiseLoading } from 'reporting-ui-components/trap/LoadingTrap';
import NoData from 'reporting-ui-components/components/shared/NoData';
import PerformanceStage from './components/PerformanceStage';
import PerformanceWell from './components/PerformanceWell';
import { eachOf } from 'reporting-ui-components/types/eachOf';
import { getStages, createConversionReport } from './PerformanceUtils';
import CustomWidgetProps from 'reporting-ui-components/lib/CustomWidgetProps';
import { UNKNOWN } from 'reporting-data/constants/errorTypes';
import getErrorTypeFromException from 'reporting-data/lib/getErrorTypeFromException';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PerformanceStages = ({
  report,
  performanceReport,
  onDrilldown,
  setIsRendered,
  errorRenderer,
  noDataRenderer,
  onReportResolve
}) => {
  const [currentReport, setCurrentReport] = useState();
  const [data, setData] = useState(null);
  const [resolveError, setResolveError] = useState(null);
  const renderErrorMarker = report.getIn(['displayParams', 'rhumbConfig', 'renderErrorMarker']);
  useEffect(() => {
    if (!currentReport || !reportsEqual(report, currentReport)) {
      setCurrentReport(report);
      resolve(fromJS(report), {
        v2Datasets: true
      }).then(response => {
        if (typeof setIsRendered === 'function') {
          setIsRendered();
        }
        setData(response);
        if (onReportResolve) {
          onReportResolve({
            data: response
          });
        }
      }).catch(error => {
        console.error(error);
        setResolveError(error || new Error(UNKNOWN));
      });
    }
  }, [report, currentReport, onReportResolve, setIsRendered]);
  if (resolveError != null) {
    if (errorRenderer) {
      return errorRenderer(resolveError, currentReport);
    }
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      flexGrow: 1,
      children: [/*#__PURE__*/_jsx(RaiseError, {
        type: getErrorTypeFromException(resolveError),
        error: resolveError
      }), renderErrorMarker && renderErrorMarker()]
    });
  }
  if (!data) {
    return /*#__PURE__*/_jsx(RaiseLoading, {});
  }
  if (data.getIn(['primary', 'data', 'data']).count() === 0) {
    return noDataRenderer ? noDataRenderer() : /*#__PURE__*/_jsx(NoData, {});
  }
  const stages = getStages(data, performanceReport, onDrilldown);
  return /*#__PURE__*/_jsx(PerformanceWell, {
    children: stages.map(stage => /*#__PURE__*/_jsx(PerformanceStage, Object.assign({}, stage, {
      performanceReport: performanceReport
    }), stage.property))
  });
};
class MarketingPerformanceViz extends Component {
  constructor(...args) {
    super(...args);
    this.onDrilldownClick = (config, keys) => {
      const {
        onDrilldown,
        options = {}
      } = this.props;
      const metric = keys.get(config.get('dimensions').count());
      const name = I18n.text(`reporting-ui-components.customWidgets.performanceWidget.names.${metric}`);
      if (typeof onDrilldown === 'function') {
        generateDrilldownReport(fromJS({
          config,
          displayParams: {}
        }), keys, Object.assign({}, options, {
          name
        })).then(onDrilldown);
      }
    };
  }
  render() {
    const {
      report,
      errorRenderer,
      setIsRendered,
      noDataRenderer,
      onReportResolve
    } = this.props;
    return /*#__PURE__*/_jsx(PerformanceStages, {
      report: createConversionReport(report),
      performanceReport: report,
      onDrilldown: this.onDrilldownClick,
      setIsRendered: setIsRendered,
      errorRenderer: errorRenderer,
      noDataRenderer: noDataRenderer,
      onReportResolve: onReportResolve
    });
  }
}
MarketingPerformanceViz.propTypes = Object.assign({}, CustomWidgetProps, {
  report: eachOf([CustomWidgetProps.report, immutablePropTypes.contains({
    displayParams: immutablePropTypes.contains({
      customWidget: immutablePropTypes.contains({
        options: immutablePropTypes.contains({
          showOfflineSources: PropTypes.bool,
          goals: immutablePropTypes.listOf(immutablePropTypes.contains({
            property: PropTypes.string.isRequired,
            goal: PropTypes.number.isRequired
          }).isRequired)
        })
      })
    })
  }).isRequired])
});
export default MarketingPerformanceViz;